<template>
	<div class="user-center-container">
		<div class="user-center-content">
			<div class="section-sub-title">
				<h4>提交企业认证信息</h4>
			</div>

			<div class="custom-form-container">
				<el-form ref="authForm" :model="authForm" :rules="rules" label-width="170px">
					<div class="custom-form-row">
						<el-form-item label="姓名：" prop="realName" class="custom-form-item">
							<el-input v-model="authForm.realName" placeholder="请输入姓名"></el-input>
						</el-form-item>

						<el-form-item label="手机号：" prop="userPhone" class="custom-form-item">
							<el-input v-model="authForm.userPhone" placeholder="请输入手机号"></el-input>
						</el-form-item>
					</div>

					<div class="custom-form-row">
						<el-form-item label="企业名称：" prop="companyName" class="custom-form-item">
							<el-input v-model="authForm.companyName" placeholder="请输入企业名称"></el-input>
						</el-form-item>

						<el-form-item label="企业社会信用代码：" prop="companyCode" class="custom-form-item">
							<el-input v-model="authForm.companyCode" placeholder="请输入企业社会信用代码"></el-input>
						</el-form-item>
					</div>

					<div class="custom-form-row">
						<el-form-item label="认证文件类型：" prop="fileType" class="custom-form-item">
							<el-select v-model="authForm.fileType" placeholder="请选择">
								<el-option label="营业执照" value="1"></el-option>
								<el-option label="对公打款证明" value="2"></el-option>
								<el-option label="在职证明" value="3"></el-option>
							</el-select>
						</el-form-item>
					</div>

					<div class="custom-form-row">
						<el-form-item :label="uploadLabelText" prop="" class="custom-form-item">
							<div class="upload-container">
								<el-upload
									ref="applyUpload"
									:action="uploadParams.action"
									:name="uploadParams.fileName"
									:limit="uploadParams.limit"
									:data="{ companyApplyAuthId: companyApplyAuthId, fileType: authForm.fileType }"
									:headers="{ InternetToken: uploadParams.InternetToken }"
									:on-exceed="onExceed"
									:before-upload="handleBeforeUpload"
									:on-success="handUploadFileSuccess"
									:on-error="handUploadFileError"
									:show-file-list="false"
									drag
									:accept="uploadParams.accept"
								>
									<i class="el-icon-upload"></i>
									<div class="el-upload__text">
										将文件拖到此处，或
										<em>点击上传</em>
									</div>
									<div class="el-upload__tip" slot="tip">
										仅支持上传 1 个文件，格式为 jpg、png 或 pdf，且文件大小不超过 100MB。
									</div>
								</el-upload>
								<!-- 右侧添加示例图片 -->
								<el-row class="file-list-wrap">
									<span>示例：</span>
									<!-- 图片 -->
									<el-image style="width: 135px; height: 135px" :src="url" :fit="fit" :preview-src-list="srcList"></el-image>
								</el-row>
							</div>

							<!-- 文件预览列表 -->
							<div v-if="authForm.filePath" class="file-preview-list">
								<div class="file-item">
									<div class="file-info">
										<i class="el-icon-document"></i>
										<span class="file-name">{{ authForm.fileName }}</span>
									</div>
									<div class="file-actions">
										<!-- <el-button type="text" size="small" @click="previewFile(authForm.filePath)">
											<i class="el-icon-view"></i>
											预览
										</el-button>
										<el-button type="text" size="small" @click="downloadFile(authForm.filePath)">
											<i class="el-icon-download"></i>
											下载
										</el-button> -->
									</div>
								</div>
							</div>

							<!-- 上传须知 -->
							<div v-if="currentTips.length > 0" class="upload-tips">
								<div class="tips-title">{{ tipsTitle }}</div>
								<ul class="tips-list">
									<li v-for="(tip, index) in currentTips" :key="index">{{ tip }}</li>
								</ul>
							</div>
						</el-form-item>
					</div>

					<div class="custom-form-row">
						<div class="custom-form-item btn-group">
							<el-button @click="handleCancelConmpanyAuth">取消</el-button>
							<el-button type="primary" @click="handleConmpanyAuth">提交审核</el-button>
						</div>
					</div>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import { getToken } from '@/utils/auth'
	import { getUuid } from '@/utils'
	import { mapGetters } from 'vuex'
	import { validateMobile } from '@/utils/jr-validate'
	import {
		uploadAuthFile,
		saveCompanyAuth,
		previewAuthFile,
		downloadAuthFile,
		detailCompanyAuthById
	} from '@/api/userCenter/companyAuth.js'

	// 企业认证材料提交
	export default {
		name: 'CompanyAuth',
		components: {},
		props: {},
		data() {
			return {
				uploadParams: {
					action: uploadAuthFile(),
					fileName: 'file',
					limit: 1,
					accept: '.jpg,.jpeg,.png,.pdf',
					InternetToken: getToken()
				},
				authForm: {
					// ID 编号
					id: '',
					// 用户id
					userId: '',
					// 申请认证人
					realName: '',
					// 手机号
					userPhone: '',
					// 企业名称
					companyName: '',
					// 企业社会代码
					companyCode: '',
					// 企业邮箱
					email: '',
					// 认证文件类型（1营业执照，2对公打款，3在职证明）
					fileType: '',
					// 认证文件名称
					fileName: '',
					// 认证文件地址
					filePath: '',
					// 审核状态 0 待审核 1审核通过 2审核不通过 3过期
					auditState: '0',
					// 审核通过时间
					auditTime: ''
				},
				// 不同文件类型的提示信息
				tipsList: {
					'1': [
						'营业执照清晰完整，不能剪裁',
						'不支持手机屏幕截图和电脑翻拍照片',
						'营业执照的黑白复印件、扫描件、需加盖红色公司公章',
						'营业执照二维码能识别出本公司信息',
						'如公司信息已变更，请上传最新营业执照',
						'营业执照与公司全称一致'
					],
					'2': [
						'打款证明清晰完善，不能裁剪',
						'不支持手机屏幕截图和电脑翻拍图片',
						'公对公黑白复印件、扫描件，需加盖红色公司公章',
						'公对公打款信息与公司全称一致'
					],
					'3': [
						'证明清晰完善，不能裁剪',
						'不支持手机屏幕截图和电脑翻拍图片',
						'黑白复印件、扫描件，需加盖红色公司公章',
						'盖章信息与公司全称一致'
					]
				},
				rules: {
					realName: [{ required: true, trigger: 'blur', message: '请输入用户名' }],
					companyName: [{ required: true, trigger: 'blur', message: '请输入企业名称' }],
					companyCode: [{ required: true, trigger: 'blur', message: '请输入企业社会代码' }],
					fileType: [{ required: true, trigger: 'change', message: '请选择认证文件类型' }],
					userPhone: [
						{ required: true, trigger: 'blur', message: '请输入手机号' },
						{ validator: validateMobile, trigger: 'blur' }
					]
				},
				// 定义 fit 属性
				fit: 'cover'
			}
		},
		computed: {
			...mapGetters(['userId', 'phone', 'realName']),
			// 当前选中的文件类型对应的提示信息
			currentTips() {
				return this.tipsList[this.authForm.fileType] || []
			},
			// 提示标题
			tipsTitle() {
				const titleMap = {
					'1': '上传营业执照须知：',
					'2': '上传对公打款证明须知：',
					'3': '上传在职证明须知：'
				}
				return titleMap[this.authForm.fileType] || '上传须知：'
			},
			// 上传标签文本
			uploadLabelText() {
				const labelMap = {
					'1': '营业执照：',
					'2': '对公打款证明：',
					'3': '在职证明：'
				}
				return labelMap[this.authForm.fileType] || '认证材料：'
			},
			// 申请注册企业记录表id
			companyApplyAuthId() {
				if (this.$route.query.id) {
					return this.$route.query.id
				} else {
					return getUuid()
				}
			},
			// 示例图
			url() {
				const titleMap = {
					'1': require('@/assets/employment/samplePicture.png'),
					'2': require('@/assets/employment/businessToBusiness.png'),
					'3': require('@/assets/employment/zzzm.png')
				}
				return titleMap[this.authForm.fileType] || require('@/assets/employment/samplePicture.png')
			},
			// 预览示例图
			srcList() {
				const titleMap = {
					'1': [require('@/assets/employment/samplePicture.png')],
					'2': [require('@/assets/employment/businessToBusiness.png')],
					'3': [require('@/assets/employment/zzzm.png')]
				}
				return titleMap[this.authForm.fileType] || [require('@/assets/employment/samplePicture.png')]
			}
		},
		watch: {
			// 监听文件类型变化，重置上传组件
			'authForm.fileType'(newVal) {
				if (this.$refs.applyUpload) {
					this.$refs.applyUpload.clearFiles()
				}
			}
		},
		created() {},
		mounted() {
			this.authForm.companyName = this.$route.query?.companyName
			this.authForm.companyCode = this.$route.query?.companyCode
			this.authForm.realName = this.realName
			this.authForm.userPhone = this.phone
			if (this.$route.query.id) {
				// 获取企业认证信息
				this.handleGetCompanyAuthInfo()
			}
		},
		methods: {
			// 上传前开启Loding
			handleBeforeUpload(file) {
				// 是否选择认证文件类型
				if (!this.authForm.fileType) {
					this.$modal.msgError('请选择认证文件类型')
					return false
				}
				this.$modal.loading('正在上传...')
				// 格式为 jpg、png 或 pdf，且文件大小不超过 100MB
				const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png'
				const isPDF = file.type === 'application/pdf'
				const isAllowedType = isJPGOrPNG || isPDF
				const isLt100M = file.size / 1024 / 1024 < 100

				if (!isAllowedType) {
					this.$message.error('上传文件只能是 JPG、PNG 或 PDF 格式!')
					this.$modal.closeLoading()
				}
				if (!isLt100M) {
					this.$message.error('上传文件大小不能超过 100MB!')
					this.$modal.closeLoading()
				}
				return isAllowedType && isLt100M
			},

			// 文件选择超出个数时的回调
			onExceed() {
				this.$modal.msgWarning(`最多选择${this.uploadParams.limit}个文件`)
			},

			// 上传成功回调
			handUploadFileSuccess(response) {
				if (response && response.code === 200) {
					this.$message.success('上传成功')
					// 保存文件路径
					this.authForm.filePath = response.data.filePath
					this.authForm.fileName = response.data.fileName
				} else {
					this.$message.error(`上传失败${response.message}`)
				}
				this.$modal.closeLoading()
				// 上传成功之后清除历史记录
				this.$refs.applyUpload.clearFiles()
			},

			// 上传失败回调
			handUploadFileError() {
				this.$message.error('上传失败')
				this.$modal.closeLoading()
			},

			// 获取文件名
			getFileName(filePath) {
				if (!filePath) return ''
				// 从路径中提取文件名
				return filePath.substring(filePath.lastIndexOf('/') + 1)
			},

			// 预览文件
			previewFile() {
				window.open(previewAuthFile({ companyApplyAuthId: this.companyApplyAuthId }), '_blank')
			},

			// 下载文件
			downloadFile(filePath) {
				if (!filePath) return

				// 创建一个隐藏的a标签用于下载
				const link = document.createElement('a')
				link.style.display = 'none'
				link.target = '_blank'
				link.href = downloadAuthFile({ companyApplyAuthId: this.companyApplyAuthId })
				link.setAttribute('download', this.getFileName(filePath))
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			},

			// 提交审核
			handleConmpanyAuth() {
				this.$refs.authForm.validate(valid => {
					if (valid) {
						if (!this.authForm.filePath) {
							this.$modal.msgWarning('请上传认证材料')
							return
						}

						// 验证通过，提交表单
						const data = {
							...this.authForm,
							id: this.companyApplyAuthId,
							userId: this.userId
						}

						saveCompanyAuth(data)
							.then(response => {
								this.$modal.msgSuccess('提交成功')
								this.$router.push({ path: '/user/common/company' })
							})
							.catch(error => {
								this.$modal.msgError('提交失败')
							})
					}
				})
			},

			// 取消认证
			handleCancelConmpanyAuth() {
				this.$router.push({ path: '/user/common/company' })
			},

			// 查询企业已有认证信息
			handleGetCompanyAuthInfo() {
				const params = {
					companyApplyAuthId: this.companyApplyAuthId
				}

				detailCompanyAuthById(params)
					.then(response => {
						const { data } = response

						this.authForm = {
							...data,
							fileType: data.fileType.toString()
						}
					})
					.catch(error => {
						this.$modal.msgError('获取企业认证信息失败')
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';

	.custom-form-container {
		.custom-form-row {
			display: flex;
			margin-bottom: 10px;

			&:last-child {
				margin-bottom: 0;
			}

			.custom-form-item {
				flex: 1;
				// display: flex;
				// align-items: center;
				position: relative;

				&:first-child {
					margin-right: 20px;
				}

				&.btn-group {
					display: flex;
					justify-content: center;

					.el-button {
						font-size: 16px;
					}
					.el-button + .el-button {
						margin-left: 20px;
					}
				}

				::v-deep {
					.el-form-item__label {
						padding-right: 10px;
						color: #333333;
						font-size: 16px;
					}

					.el-input {
						font-size: 16px;
					}
				}
			}
		}

		.file-preview-list {
			margin-top: 15px;
			border: 1px solid #e6e6e6;
			border-radius: 4px;

			.file-item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px 15px;
				background-color: #f9f9f9;

				.file-info {
					display: flex;
					align-items: center;

					i {
						color: #409eff;
						font-size: 20px;
						margin-right: 8px;
					}

					.file-name {
						color: #333;
						font-size: 14px;
						word-break: break-all;
					}
				}

				.file-actions {
					display: flex;
					align-items: center;

					.el-button {
						margin-left: 10px;
						padding: 0;

						i {
							margin-right: 3px;
						}
					}
				}
			}
		}

		.upload-tips {
			margin-top: 15px;
			padding: 15px;
			background-color: #f8f8f8;
			border-radius: 4px;

			.tips-title {
				color: #333;
				font-size: 16px;
				font-weight: 500;
				margin-bottom: 10px;
			}

			.tips-list {
				padding-left: 20px;
				margin: 0;

				li {
					color: #666;
					font-size: 16px;
					line-height: 24px;
					position: relative;
					list-style-type: none;

					&::before {
						content: '•';
						color: #1890ff;
						position: absolute;
						left: -35px;
						font-size: 40px;
					}
				}
			}
		}
	}
	.upload-container {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
	}
	.file-list-wrap {
		display: flex;
		flex-direction: column;
		margin-left: 50px;
	}
</style>
